import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  DateField,
  Resource,
  Show,
  Filter,
  Datagrid,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  EditButton,
  AutocompleteInput,
} from "react-admin";

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="Article category"
      source="articleCategoryId"
      reference="articleCategory"
      alwaysOn
      filterToQuery={searchText => ({ name: searchText })}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const DefaultArticlePackagingList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <ReferenceField
            label="Article category"
            source="articleCategoryId"
            reference="articleCategory"
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Packaging"
            source="packagingId"
            reference="process/packaging"
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Reusable alternative"
            source="reusableAlternativeId"
            reference="process/packaging"
            allowEmpty
          >
            <TextField source="name" />
          </ReferenceField>

          <TextField label="Retail group" source="type" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowDefaultArticlePackaging = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="id" />
        <ReferenceField
          label="Article category"
          source="articleCategoryId"
          reference="articleCategory"
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          label="Packaging"
          source="packagingId"
          reference="process/packaging"
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          label="Reusable alternative"
          source="reusableAlternativeId"
          reference="process/packaging"
          allowEmpty
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField label="Retail group" source="type" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateDefaultArticlePackaging = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput
          label="Article category"
          source="articleCategoryId"
          reference="articleCategory"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
          label="Packaging"
          source="packagingId"
          reference="process/packaging"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
          label="Reusable alternative"
          source="reusableAlternativeId"
          reference="process/packaging"
          filterToQuery={searchText => ({ name: searchText })}
          allowEmpty
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <SelectInput
          source="type"
          label="Retail group"
          choices={[
            { id: 'Online', name: 'online' },
            { id: 'Offline', name: 'offline' },
          ]}
          translateChoice={true}
        />
      </SimpleForm>
    </Create>
  );
};

const EditDefaultArticlePackaging = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <ReferenceInput
          label="Article category"
          source="articleCategoryId"
          reference="articleCategory"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
          label="Packaging"
          source="packagingId"
          reference="process/packaging"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
          label="Reusable alternative"
          source="reusableAlternativeId"
          reference="process/packaging"
          filterToQuery={searchText => ({ name: searchText })}
          allowEmpty
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <SelectInput
          source="Retail group"
          choices={[
            { id: 'Online', name: 'online' },
            { id: 'Offline', name: 'offline' },
          ]}
          translateChoice={true}
        />
      </SimpleForm>
    </Edit>
  );
};

const defaultArticlePackagingResource = () => (
  <Resource
    name="defaultArticlePackagings"
    options={{ label: 'Default Article Packaging', menuGroup: 'Bcome' }}
    list={DefaultArticlePackagingList}
    create={CreateDefaultArticlePackaging}
    edit={EditDefaultArticlePackaging}
    show={ShowDefaultArticlePackaging}
  />
);

export default defaultArticlePackagingResource;
